import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { } from 'events';
import { ThankYou_Message } from 'src/app/common-class/survey-messages';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { OfflineSurvey } from '../../common-class/survey';
import { Observable, Subscription, timer, interval } from 'rxjs';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { EncryptionAndDecryption } from '../../COMMON-LOGIC/EncryptionAndDecryption';
import { PostMessgesData } from 'src/app/common-class/Post-message-data';
declare var $: any;

@Component({
  selector: 'app-thank-you-message',
  templateUrl: './thank-you-message.component.html',
  styleUrls: ['./thank-you-message.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThankYouMessageComponent implements OnInit {
  @Input() ThankYouMessage: ThankYou_Message;
  @Input() ResponseRecorded: string;
  @Input() PoweredByText: string;
  @Input() isReopenResponse: boolean;
  @Input() ReopenText: string;
  @Input() surveyWidthType: number;
  @Input() isMobile:boolean;
  @Input() SurveyLogoImageUrl:string;
  @Input() SurveyLogoAlign:number;
  @Input() isShowPartial: boolean = false;
  @Input() isPowredByClient : boolean;

  @Output() EditResponceHandling: EventEmitter<any> = new EventEmitter();
  @Output() StartNewResponse: EventEmitter<any> = new EventEmitter();


  href: string;
  isRTL: boolean;
  thankYouGifURL: string;
  isPreview: boolean = false;
  selectedLang: number;
  urlParam: string;
  isOfflineSurvey: boolean = false;
  private timer: Observable<any>;
  private subscription: Subscription;
  OfflineResponseData: any =[];
  postMessgesData : PostMessgesData;


  constructor(private service: ParticipationDataService, private router: Router,
    private activatedRoute: ActivatedRoute, private offlineSurvey: OfflineSurvey,
     @Inject(LOCAL_STORAGE) private storage: StorageService) {

      if (this.offlineSurvey != undefined && this.offlineSurvey.isOfflineSurvey) {
        this.isOfflineSurvey=this.offlineSurvey.isOfflineSurvey;
      }
    }

  ngOnInit() {
    this.isRTL = this.service.isRTL;
    this.thankYouGifURL = "static/images/ThankYouPage.gif?" + this.ThankYouMessage.SurveyURL;
    const head = document.getElementsByTagName('head')[0];    
           let node = document.createElement('script'); // creates the script tag
             node.text = '     $(document).ready(function () {'+  this.ThankYouMessage.customScript+'});'; // sets the source (insert url in between quotes)
           node.type = 'text/javascript'; // set the script type
          head.appendChild(node);
    this.setTimer();

    if (this.isOfflineSurvey) {
      let k = '';
      this.activatedRoute.queryParams.subscribe(async params => {
        k = params['k'];
      });
      let encryptedData = this.storage.get('ResponseData_' + k) || [];

      if (encryptedData.length > 0) {
        encryptedData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', encryptedData);
        this.OfflineResponseData = JSON.parse(encryptedData);
      }
    }

    if (this.isShowPartial) {
      if (window.parent) {
        window.parent.parent.scrollTo(0, 0);
      }
    }


  }

  EditResponce() {
    this.EditResponceHandling.emit(null);
  }

  ngAfterViewInit() {
    var self = this;
    $('document').ready(function () {
     // $(window).on('load', function () {
      if(self.ThankYouMessage.isPrint == "0" && self.ThankYouMessage.isRedirect == "0" && self.ThankYouMessage.isThankYou == "0" && self.ThankYouMessage.isBarGraph == "0")
      {
            parent.window.close();window.close();
      }

       var URL = this.abc;
        var window_width = $(window).width();
        var window_height = $(window).height();
        if (window_width <= 900 || window_height < 600) {
            $('#chainLink.activate_modal').attr('href', "javascript:void(0);")
            $('#chainLink.activate_modal').unbind('click');
            $('#chainLink.activate_modal').attr({ onclick: "javascript:window.open('" + self.ThankYouMessage.ViralURL.replace('/\'/g', '') + "','_blank')" })
            $('#mobViralLink.thnk-option').attr({ onclick: "javascript:window.open('" + self.ThankYouMessage.ViralURL.replace('/\'/g', '') + "','_blank')" })
        }
        else {
            $('#chainLink.activate_modal').attr('href', 'javascript:void(0);');
            $('#chainLink.activate_modal').click(function () {
                $('#chainmodalIframeDiv').attr('src', self.ThankYouMessage.ViralURL.replace('/\'/g', ''));
                var modal_id = $(this).attr('name');
                show_modal(modal_id);
            });
            $('.modalWindow').each(function () {
                var modal_height = $(this).height() + 14;
                var modal_width = $(this).width();
                var top = ((window_height - modal_height) / 2);
                var left = (window_width - modal_width) / 2;
                $(this).css({
                    'top': top,
                    'left': left
                });
            });
            $('.close_modalviral').click(function () {
                close_modal('viralinvitepop');
                clear_chain_iframe();
            });
        }
        function close_modal(modaldiv) {
          $('#mask').fadeOut(500);
          $('#' + modaldiv).fadeOut(500);
        }
        function clear_chain_iframe() {
          $('#chainmodalIframeDiv').attr("src", self.ThankYouMessage.ViralURL)
        }
        function show_modal(modal_id) {
         $('#mask').css({
              'display': 'block',
              opacity: 0
          });
          $('#mask').fadeTo(500, 0.8);
          $('#' + modal_id).fadeIn(500);
          var modal_height = $('#' + modal_id).height();
          var modal_width = $('#' + modal_id).width();
          var top = ((modal_height) / 2);
          var left = (modal_width) / 2;
          $('#' + modal_id).css({
              'top': '50%' ,
              'left': '50%' ,
              'margin-top': -top,
              'margin-left': -left,
              'position' : 'fixed'
          });
        }
     // });
     if(self.ThankYouMessage.CategoryScore != undefined && self.ThankYouMessage.CategoryScore !="")
     {
      window["DisplayCategoryGraph"]('dv_CatGraph','',self.ThankYouMessage.CategoryScore);
      var base64Img;
      setTimeout(() => {
        var chart = $('#dv_CatGraph').highcharts();
        var graphData = chart.getSVG();
        base64Img = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(graphData)));
      },1000);
      setTimeout(() => {
        window["sendCatGraphImage"](base64Img,self.service.getRecNO());
      }, 1001);
     }
     setTimeout(() => {
      
      if (window.location !== window.parent.location && $('body').hasClass('embed-survey')) {
        let docHeight = document.documentElement.scrollHeight;
        if ($('.thankYouMsgWrapper').height() != undefined && $('.thankYouMsgWrapper').height() != 0) {
          docHeight = $('.thankYouMsgWrapper').height();
        }
        if ($('.navigation-band').height() != undefined && $('.navigation-band').height() != 0) {
          docHeight += $('.navigation-band').height();
        }
        // if($('form').height() != undefined && $('form').height()!=0){
        //   docHeight = $('form').height();
        // }

        this.postMessgesData = new PostMessgesData()
        this.postMessgesData.action = 'Submit Button Click';
        this.postMessgesData.data = '';
        this.postMessgesData.height = docHeight+250;
        this.postMessgesData.width = document.documentElement.scrollWidth;
        this.postMessgesData.embedid = self.service.getCommonSetting().embedID;
        parent.postMessage(JSON.stringify(this.postMessgesData), "*");
        $('body').css('height', 'auto');
        $('body').getNiceScroll().remove();
      } 
    }, 200);
    });

    if($('.mobile-wrapper').length > 0){
      this.calcTyWrapperHt();
    }
    setTimeout(() => {
      //$('body').css('height', 'auto');
      // $('body').getNiceScroll().resize();
      let self = this;
      if (!(!(self.service.getGroupType().toLowerCase() == 'preview') && self.service.getMobile())||self.service.getCommonSetting().isEmbedMobile ||self.service.getCommonSetting().isEmbedPopMobile) {
        $('body').getNiceScroll().resize();
      }
    }, 100);

    // $(".tab").on('click', function(event){
    //   $('.tab').removeClass('active');
    //   $('.tab-content').removeClass('active');
    //   const tabname = $(this).attr('name');
    //   $("[name='"+tabname+"']").addClass("active");
    // });
    setTimeout(() => {
      if(!$('body').hasClass('embed-survey'))
      {
          self.bottomfooterPos();
      }
    }, 100);
    
  }

  calcTyWrapperHt(){
    if (!(window.location !== window.parent.location && $('body').hasClass('embed-survey'))) {
    let tyMsgWrapperHt = $(window).height() - $('.thank-you-footer').outerHeight(); //80 is the padding of ty wrapper
    $('.thankYouMsgWrapper').css('min-height', tyMsgWrapperHt + 'px');
    }
  }

  OfflineDashboard() {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    document.title = "Offline Home -" + this.offlineSurvey.surveyno;
    let path = 'offline.aspx?' + this.GetUrlData(false);
    this.router.navigateByUrl(path);
  }

  RecordResponse​() {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    // let path = 'Survey1.aspx?' + this.GetUrlData(false);
    // this.router.navigateByUrl(path);
    this.StartNewResponse.emit();
  }

  GetUrlData(isLoading: boolean): any {
    this.activatedRoute.queryParams.subscribe(async params => {
      let k = params['k'];
      let Uid=""
      let Dir=""
      let lang = (params['lang'] == "" || params['lang'] == undefined) ? "0" : params['lang'];
      let goBackQuota = (params['isGoBackQuota'] == "" || params['isGoBackQuota'] == undefined) ? "" : "&isGoBackQuota=true";
      let isEmbedMobile   = (params['isEmbedMobile']=="" || params['isEmbedMobile'] == undefined)?"" : "&isEmbedMobile=1"
      let isEmbedPopMobile   = (params['isEmbedPopMobile']=="" || params['isEmbedPopMobile'] == undefined)?"" : "&isEmbedPopMobile=1"
      let isPartial =  (params['isPartial']=="" || params['isPartial'] == undefined)?"" : "&isPartial=True"

      if (lang == undefined) {
        lang = (params['lang'] == "" || params['lang'] == undefined) ? "0" : params['lang'];
      }

      let status = (params['status'] != undefined || params['status'] != null || params['Status'] != undefined || params['Status'] != null ? '&status=preview' : '');

      if(status == '&status=preview'){
        this.isPreview = true;
        let isThankYou =  (params['isThankYou']=="" || params['isThankYou'] == undefined)?"" : "&isThankYou="+ params['isThankYou']
        let type =  (params['type'] == "" || params['type'] == undefined)?"" : "&type=" + params['type']
        let msgId =  (params['msgId'] == "" || params['msgId'] == undefined)?"" : "&msgId=" + params['msgId']
        status = status + isThankYou + type + msgId;
        // if ($("#hdnCurrentLang", parent.document).val() != -1 && $("#hdnCurrentLang", parent.document).val()) {
        //   lang = $("#hdnCurrentLang", parent.document).val();
        // }
      }

      if (!isLoading) {
        // lang = this.selectedLang != undefined || this.selectedLang != null ? (this.selectedLang != this.surveyData.SurveySettings.primary_lang_id ? this.selectedLang : "0" ) : "0";
        // //Dir = '&Dir=FST';
      }
      if (isLoading) {
        Uid = (params['Uid'] == "" || params['Uid'] == undefined) ? "" : '&responseUID=' + params['Uid'];
        Dir = (params['Dir'] == "" || params['Dir'] == undefined) ? "" : '&Dir=' + params['Dir'];
      }

      let data = params['data'];

      this.urlParam = 'k=' + k + '&lang=' + lang + Uid + status+ Dir + goBackQuota + isEmbedMobile +isEmbedPopMobile + isPartial;
      this.selectedLang = lang;
    });
    return this.urlParam;
  }

  public setTimer() {
    if (this.isOfflineSurvey) {
      this.timer = timer((1 * 1000) *  this.offlineSurvey.Thankyoumessagetimeout);

      if(this.subscription){
        this.subscription.unsubscribe();
      }

      // if(this.subscription_2){
      //   this.subscription_2.unsubscribe();
      // }

      this.subscription = this.timer.subscribe(() => {
        setTimeout(() =>{
          document.title = "Offline Home -" + this.offlineSurvey.surveyno;
          let path = 'offline.aspx?' + this.GetUrlData(false);
          this.router.navigateByUrl(path);
        },100);
      });
    }
  }

  bottomfooterPos() {

    //alert($(window).height());
    var docHeight = $(window).height();

    var footerHeight = $('.main-footer-div').height();

    var footerTop = $('.main-footer-div').position().top + footerHeight;

    if (footerTop < docHeight) {

      $('.main-footer-div').css('margin-top', (docHeight - footerTop) - 40 + 'px');

    }

  }
}
